import React from "react";
import AppRoutes from "./routes";
import useGoogleAnalytics from "./utils/hooks/useGoogleAnalytics";

const App = () => {
	useGoogleAnalytics();
	return <AppRoutes />;
};
export default App;
